import { z } from 'zod'
import { ShoppingPromotionSchema } from '@reward-platform/shared-schemas'
import { CurrencyCodesSchema } from '@reward-platform/platform-config'
import {
  PaginationSchema,
  PriceLadderSchema,
  DurationSchema,
  PricedPaymentOptionSchema,
  ResponseShoppingFilterSchema,
} from '../../common'

export const ExperienceSearchResult = z.object({
  bundleId: z.string(),
  productId: z.string().optional(),
  vendorName: z.string().optional(),
  name: z.string(),
  description: z.string(),
  duration: DurationSchema.optional(),
  cashPrice: z.number(),
  collectAmount: z.number(),
  aviosPrice: z.number(),
  pricingLadder: z.array(PriceLadderSchema).optional(),
  paymentOptions: z.array(PricedPaymentOptionSchema).optional(),
  imageUrl: z.string().optional(),
  guestRating: z.number().optional(),
  guestRatingCount: z.number().optional(),
  currencyCode: CurrencyCodesSchema,
  promotions: z.array(ShoppingPromotionSchema).optional(),
  baseLoyalty: z.number().optional(),
})

export const ExperienceSearchDataTransferObjectSchema = z.object({
  correlationId: z.string(),
  recommendationId: z.string(),
  results: z.array(ExperienceSearchResult),
  // TODO: pagination should not be optional
  pagination: PaginationSchema.optional(),
  shoppingFilter: ResponseShoppingFilterSchema.optional(),
})

export type ExperienceSearchOffer = z.infer<typeof ExperienceSearchResult>
export type ExperienceSearchDataTransferObject = z.infer<
  typeof ExperienceSearchDataTransferObjectSchema
>
